import React from "react"
import styled from "styled-components"

const StyledContainer = styled.div`
  margin-top: 10px;
  margin-bottom: 40px;
  padding-left: 10px;
  padding-right: 10px;
`

const Header = styled.div`
  color: var(--white);
  text-align: left;
  margin-left: 5px;
`

type Props = {
  header: string
  children: JSX.Element | JSX.Element[]
}

const SectionContainer = ({header, children}: Props) => {
  return (
    <StyledContainer>
      <Header>{header}</Header>
      {children}
    </StyledContainer>
  )
}

export default SectionContainer